import { Component, ElementRef, HostBinding, OnInit, ViewChild } from '@angular/core';
import { SatisfactionFormService } from '../../services/satisfaction-form/satisfaction-form.service';
import { MModalite, MSatisfaction } from '@argalis-apps/models';
import { AccountConfigService } from '../../services/account-config/account-config.service';
@Component({
  selector: 'ags-satisfaction-form',
  templateUrl: './satisfaction-form.component.html',
  styleUrls: ['./satisfaction-form.component.scss']
})
export class SatisfactionFormComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @ViewChild('note') note: ElementRef<HTMLElement>;
  public listDescriptionDefaultSatisfaction: MModalite.IModalite[] = [];
  public listDescriptionOptionalSatisfaction: MModalite.IModalite[] = [];
  public defaultStatisfactionValue: MSatisfaction.ISatisfactionDefault[] = [];
  public optionalStatisfactionValue: MSatisfaction.ISatisfactionOptinal[] = [];
  public loadingUpdate = false;
  public already_completed = false;
  public satisfaction_note: string;
  public openeUpdateDialog = false;
  public errorUpdate = false;
  public errorMsg = '';
  private id_session = 24; //  TODO CHANGE IT
  private id_apprenant = 40; // TODO CHANGE IT
  constructor(
    public satisfactionFormService: SatisfactionFormService,
    private accountConfigService: AccountConfigService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.getSatisfactionDescription();
  }

  getDefaultStatisfactionValue() {
    this.satisfactionFormService.getSatisfactionDefaultValue(this.id_apprenant, this.id_session).subscribe(
      data => {
        if (data.satisfactionDefault.length > 0) {
          this.defaultStatisfactionValue = data.satisfactionDefault;
          this.already_completed = data.already_completed;
          this.satisfaction_note = data.note;
        } else {
          this.defaultStatisfactionValue = [];
          this.already_completed = data.already_completed;
          this.satisfaction_note = data.note;
          this.initSatisfactionDefaultValue();
        }
      },
      () => {
        this.defaultStatisfactionValue = [];
        this.already_completed = false;
        this.satisfaction_note = null;
        this.initSatisfactionDefaultValue();
      }
    );
  }

  getListDescriptionDefaultSatisfaction(): void {
    this.satisfactionFormService.getListDescriptionDefaultSatisfaction().subscribe(
      data => {
        if (data.length > 0) {
          this.listDescriptionDefaultSatisfaction = data;
        } else {
          this.listDescriptionDefaultSatisfaction = [];
        }
      },
      () => {
        this.listDescriptionDefaultSatisfaction = [];
      }
    );
  }

  getListDescriptionOptionalSatisfaction(): void {
    this.satisfactionFormService.getListDescriptionOptionalSatisfaction(this.id_session).subscribe(
      data => {
        if (data.length > 0) {
          this.listDescriptionOptionalSatisfaction = data;
        } else {
          this.listDescriptionOptionalSatisfaction = [];
        }
      },
      () => {
        this.listDescriptionOptionalSatisfaction = [];
      }
    );
  }

  getOptionalStatisfactionValue(): void {
    this.satisfactionFormService.getSatisfactionOptionalValue(this.id_apprenant, this.id_session).subscribe(
      data => {
        if (data.length > 0) {
          this.optionalStatisfactionValue = data;
        } else {
          this.optionalStatisfactionValue = [];
          this.initSatisfactionOptional();
        }
      },
      () => {
        this.optionalStatisfactionValue = [];
        if (this.listDescriptionOptionalSatisfaction.length > 0) {
          this.initSatisfactionOptional();
        }
      }
    );
  }

  updateCheckedDefaultQuestion(question_id: number, valueChecked: number, event): void {
    if (event.target.checked) {
      for (const index in this.defaultStatisfactionValue) {
        if (Number(this.defaultStatisfactionValue[index].id_question) === Number(question_id)) {
          this.defaultStatisfactionValue[index].value = valueChecked;
        }
      }
    } else {
      for (const index in this.defaultStatisfactionValue) {
        if (Number(this.defaultStatisfactionValue[index].id_question) === Number(question_id)) {
          this.defaultStatisfactionValue[index].value = -1;
        }
      }
    }
  }

  checkCheckedBoxDefault(question_id: number, value: number): boolean {
    if (this.defaultStatisfactionValue.length > 0) {
      return (
        this.defaultStatisfactionValue.filter(elm => elm.value === value && elm.id_question === question_id).length ===
        1
      );
    } else {
      return false;
    }
  }

  initSatisfactionDefaultValue(): void {
    if (this.listDescriptionDefaultSatisfaction) {
      if (this.defaultStatisfactionValue.length === 0) {
        for (const elem of this.listDescriptionDefaultSatisfaction) {
          this.defaultStatisfactionValue.push({ id_question: elem.id, value: -1 });
        }
      }
    }
  }

  updateCheckedOptionalAfterQuestion(question_id: number, valueChecked: number, event): void {
    if (event.target.checked) {
      for (const index in this.optionalStatisfactionValue) {
        if (Number(this.optionalStatisfactionValue[index].id_question) === Number(question_id)) {
          this.optionalStatisfactionValue[index].value_after = valueChecked;
        }
      }
    } else {
      for (const index in this.optionalStatisfactionValue) {
        if (Number(this.optionalStatisfactionValue[index].id_question) === Number(question_id)) {
          this.optionalStatisfactionValue[index].value_after = -1;
        }
      }
    }
  }

  updateCheckedImplementationWork(question_id: number, event): void {
    if (event.target.checked) {
      for (const index in this.optionalStatisfactionValue) {
        if (Number(this.optionalStatisfactionValue[index].id_question) === Number(question_id)) {
          this.optionalStatisfactionValue[index].implementation_work = 1;
        }
      }
    } else {
      for (const index in this.optionalStatisfactionValue) {
        if (Number(this.optionalStatisfactionValue[index].id_question) === Number(question_id)) {
          this.optionalStatisfactionValue[index].implementation_work = -1;
        }
      }
    }
  }

  updateCheckedOptionalBeforeQuestion(question_id: number, valueChecked: number, event): void {
    if (event.target.checked) {
      for (const index in this.optionalStatisfactionValue) {
        if (Number(this.optionalStatisfactionValue[index].id_question) === Number(question_id)) {
          this.optionalStatisfactionValue[index].value_before = valueChecked;
        }
      }
    } else {
      for (const index in this.optionalStatisfactionValue) {
        if (Number(this.optionalStatisfactionValue[index].id_question) === Number(question_id)) {
          this.optionalStatisfactionValue[index].value_before = -1;
        }
      }
    }
  }

  initSatisfactionOptional(): void {
    if (this.listDescriptionDefaultSatisfaction) {
      if (this.optionalStatisfactionValue.length === 0) {
        for (const elem of this.listDescriptionOptionalSatisfaction) {
          this.optionalStatisfactionValue.push({ id_question: elem.id, value_before: -1, value_after: -1 });
        }
      }
    }
  }
  checkCheckedBoxOptionalAfter(question_id: number, value: number): boolean {
    if (this.optionalStatisfactionValue.length > 0) {
      return (
        this.optionalStatisfactionValue.filter(elm => elm.value_after === value && elm.id_question === question_id)
          .length === 1
      );
    } else {
      return false;
    }
  }

  checkCheckedBoxOptionalImplementationWork(question_id: number): boolean {
    if (this.optionalStatisfactionValue.length > 0) {
      return (
        this.optionalStatisfactionValue.filter(elm => elm.implementation_work === 1 && elm.id_question === question_id)
          .length === 1
      );
    } else {
      return false;
    }
  }

  checkCheckedBoxOptionalBefore(question_id: number, value: number): boolean {
    if (this.optionalStatisfactionValue.length > 0) {
      return (
        this.optionalStatisfactionValue.filter(elm => elm.value_before === value && elm.id_question === question_id)
          .length === 1
      );
    } else {
      return false;
    }
  }

  getSatisfactionDescription() {
    this.getListDescriptionOptionalSatisfaction();
    this.getListDescriptionDefaultSatisfaction();
  }
  getSatisfactionValue() {
    this.getDefaultStatisfactionValue();
    this.getOptionalStatisfactionValue();
  }
  ngOnInit() {
    this.getSatisfactionValue();
  }
  updateSatisfactionValue() {
    if (!this.already_completed) {
      this.loadingUpdate = true;
      this.openeUpdateDialog = true;
      this.validatorDefaultCheckbox();
      this.validatorOptionalCheckbox();
      const defaultValidator: boolean = this.defaultStatisfactionValue.filter(elem => elem.value === -1).length === 0;
      const optionValidator: boolean =
        this.optionalStatisfactionValue.filter(elem => elem.value_after === -1 || elem.value_before === -1).length ===
        0;
      if (optionValidator && defaultValidator) {
        const updateSatisfactionValue: MSatisfaction.ISatisfactionUpdate = {
          satisfactionCompetance: this.optionalStatisfactionValue,
          satisfactionSatisfaction: this.defaultStatisfactionValue,
          note: (this.note.nativeElement as HTMLInputElement).value
            ? (this.note.nativeElement as HTMLInputElement).value
            : null
        };
        this.satisfactionFormService
          .updateSatisfactionValue(this.id_apprenant, this.id_session, updateSatisfactionValue)
          .subscribe(
            () => {
              this.errorUpdate = false;
              this.loadingUpdate = false;
              this.getSatisfactionValue();
            },
            () => {
              this.loadingUpdate = false;
              this.errorUpdate = true;
              this.errorMsg = `Une erreur est survenue, réessayez plus tard`;
              this.getSatisfactionValue();
            }
          );
      } else {
        this.openeUpdateDialog = true;
        this.errorUpdate = true;
        this.errorMsg = `Veuillez répondre à toutes les questions du formulaire avant de l'envoyer`;
        this.loadingUpdate = false;
      }
    } else {
      this.openeUpdateDialog = true;
      this.errorUpdate = true;
      this.errorMsg = `Vous avez déjà rempli ce formulaire`;
      this.loadingUpdate = false;
    }
  }

  validatorDefaultCheckbox(): void {
    for (const elem of this.defaultStatisfactionValue) {
      const questionResponse = [];
      for (const i of [1, 2, 3, 4, 5]) {
        const defaultcheckboxId = <HTMLInputElement>document.getElementById(elem.id_question + '-' + i);
        questionResponse.push(defaultcheckboxId.checked);
      }
      if (questionResponse.indexOf(true) === -1) {
        document.getElementById((elem.id_question || '').toString()).classList.add('alert-color');
      } else {
        document.getElementById((elem.id_question || '').toString()).classList.remove('alert-color');
      }
    }
  }

  validatorOptionalCheckbox(): void {
    if (this.optionalStatisfactionValue.length > 0) {
      for (const elem of this.optionalStatisfactionValue) {
        const questionResponse = [];
        for (const i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]) {
          const optionalcheckboxAfterId = <HTMLInputElement>(
            document.getElementById('before-' + elem.id_question + '-' + i)
          );
          questionResponse.push(optionalcheckboxAfterId.checked);
        }
        for (const i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]) {
          const optionalcheckboxBeforeId = <HTMLInputElement>(
            document.getElementById('after-' + elem.id_question + '-' + i)
          );
          questionResponse.push(optionalcheckboxBeforeId.checked);
        }

        if (questionResponse.filter(_ => _ === true).length !== 2) {
          document.getElementById(('optional-' + elem.id_question || '').toString()).classList.add('alert-color');
        } else {
          document.getElementById(('optional-' + elem.id_question || '').toString()).classList.remove('alert-color');
        }
      }
    }
  }

  public closeDialog() {
    this.openeUpdateDialog = false;
  }
}
